import postSimpleView from './postSimpleComponent.html';
import './postSimpleComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure';

export function postSimpleComponent() {
	return {
		bindings: {
			post: '<',
			// defaults to 'headline'
			headlineKey: '<?',
			headlineMaxLines: '<',
			// defaults to 'rich_text_body'
			textKey: '<?',
			textMaxLines: '<',
			// defaults to `false`
			hasExternalImgSource: '<?',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: postSimpleComponentCtrl,
		template: postSimpleView,
	};
}

export class postSimpleComponentCtrl {
	constructor(modal, $scope) {
		'ngInject';
		this.modal = modal;
		this.$scope = $scope;
	}

	$onInit() {
		this.hasExternalImgSource = this.hasExternalImgSource || false;
		// this allows us to style the images as squares (`background-image` added in `prepImage`)
		this.postImageStyle = {};
		this.prepHeadline();
		this.prepText();
		this.prepImage();
		this.$scope.$watch('vm.post', () => {
			this.prepImage();
		});
	}

	prepHeadline() {
		this.postHeadlineKey = 'headline';
		if (this.headlineKey) {
			this.postHeadlineKey = ensure.object(this.post).hasOwnProperty(this.postHeadlineKey)
				? this.postHeadlineKey
				: 'headline';
		}
		this.headlineLineClampClass = `line-clamp-${this.headlineMaxLines}`;
		// 18 is the current line height of the headline text set in postSimpleComponent.css
		this.headlineMaxHeight = 18 * this.headlineMaxLines + 'px';
	}

	prepText() {
		this.postTextKey = 'rich_text_body';
		if (this.textKey) {
			this.postTextKey = ensure.object(this.post).hasOwnProperty(this.textKey) ? this.textKey : 'rich_text_body';
		}
		this.textLineClampClass = `line-clamp-${this.textMaxLines}`;
		// 18 is the current line height of the headline text set in postSimpleComponent.css
		this.textMaxHeight = 18 * this.textMaxLines + 'px';
	}

	prepImage() {
		if (!this.hasExternalImgSource || !this.post.image.url) {
			return;
		}
		this.postImageStyle.backgroundImage = 'url(' + this.post.image.url + ')';
	}
}
